import React from "react";
import type Stripe from "stripe";

import { TextDate } from "@performyard/py-components";

import ScrollableTable from "../../../components/TableLite/TableLiteScrollable";
import type { ScrollableColumn } from "../../../components/TableLite/TableLiteScrollable/TableLiteScrollable";
import Typography from "../../../components/Text";

interface BillingHistoryProps {
	charges: Stripe.Charge[];
}

const BillingHistory = ({ charges }: BillingHistoryProps) => {
	const columns: ScrollableColumn[] = [
		{
			id: "price",
			label: "Price",
			isSortable: false,
			getter: (charge: Stripe.Charge) => (
				<Typography size="paragraph-3" weight="regular">
					${(charge.amount / 100).toFixed(2)}
				</Typography>
			),
			width: 100,
		},
		{
			id: "date",
			label: "Date",
			isSortable: false,
			getter: (charge) => <TextDate size="paragraph-3" date={new Date(charge.created * 1000)} />,
			width: 200,
		},
		{
			id: "cardLast4",
			label: "Card Last 4",
			isSortable: false,
			getter: (charge: Stripe.Charge) => (
				<Typography size="paragraph-3" weight="regular">
					{charge.payment_method_details?.card?.last4}
				</Typography>
			),
			width: 100,
		},
		{
			id: "name",
			label: "Name",
			isSortable: false,
			getter: (charge: Stripe.Charge) => (
				<Typography size="paragraph-3" weight="regular">
					{charge.billing_details?.name}
				</Typography>
			),
			width: 250,
		},
	];

	return (
		<div className="w-full space-y-2">
			<Typography size="paragraph-1" weight="semi-bold">
				Billing History
			</Typography>
			<ScrollableTable columns={columns} rows={charges} rowKey="_id" />
		</div>
	);
};

export default BillingHistory;
